<template>
  <v-hover v-slot="{ hover }">
    <v-card
      class="pa-2"
      :to="{ path: '/group/' + group.id, params: { id: group.id } }"
      :elevation="hover ? 12 : 2"
      :class="{ 'on-hover': hover }"
    >
      <v-img :src="group.image" height="200" class="rounded"></v-img>
      <div class="secondary--text text--lighten-1 text-caption d-flex mt-1">
        {{ group.createdAt.toDate().toDateString() }} -
        {{ group.userCount }} users
      </div>

      <div class="pt-2">
        <div class="title font-weight-bold text-h5">{{ group.name }}</div>
        <div class="secondary--text text--lighten-1 text-body-1 mt-1 mb-2">
          {{ group.description }}
        </div>

        <div class="d-flex align-center mt-4">
          <div class="text-body-2">
            Author:
            <span class="font-weight-bold">{{ group.createdBy }}</span>
          </div>
        </div>
      </div>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  props: {
    group: {
      type: Object,
      default: () => {},
    },
  },

  mounted() {
    console.log(this.group);
  },
};
</script>
